export const PRIVACY_EN = {
    "privacy.basis.consent": "Consent",
    "privacy.basis.contract": "A contract with the person",
    "privacy.basis.legal_obligation": "A legal obligation",
    "privacy.basis.vital_interest": "A vital interest",
    "privacy.basis.public_interest": "A public interest",
    "privacy.basis.legitimate_interest": "A legitimate interest",
    "privacy.kind.access": "Access to their data",
    "privacy.kind.correction": "Correction",
    "privacy.kind.erasure": "Erasure",
    "privacy.kind.withdraw_consent": "Withdrawal of consent",
    "privacy.verification.in_person_id": "Identity document seen in person",
    "privacy.verification.nafath": "Nafath",
    "privacy.verification.signed_request": "Signed request",
    "privacy.verification.registered_contact": "From the contact on record",
    "privacy.severity.low": "Low",
    "privacy.severity.medium": "Medium",
    "privacy.severity.high": "High",
    "privacy.decision.notify": "Notify the authority",
    "privacy.decision.no_notice": "Do not notify",
    "privacy.term.request_days": "Days to answer a request",
    "privacy.term.extension_days": "Days one extension adds",
    "privacy.term.breach_notice_hours": "Hours to notify a breach",
    "privacy.request_status.open": "Open",
    "privacy.request_status.fulfilled": "Answered",
    "privacy.request_status.refused": "Refused",
    "privacy.breach_status.awaiting": "Awaiting a decision",
    "privacy.breach_status.ruled": "Decided",
    "privacy.breach_status.notified": "Notified",
    "privacy.breach_status.concluded": "Closed",
    "privacy.term_status.unconfirmed": "Unconfirmed",
    "privacy.term_status.confirmed": "Confirmed",
    "privacy.overdue.true": "Overdue",
    "privacy.overdue.false": "On time",
    "privacy.hold.true": "Legal hold",
    "privacy.hold.false": "No hold",
    "screen.privacy.register.column.name": "Name",
    "screen.privacy.register.column.category": "Category",
    "screen.privacy.register.column.basis": "Lawful basis",
    "screen.privacy.register.column.purpose": "Purpose",
    "screen.privacy.register.column.recipients": "Who receives it",
    "screen.privacy.register.column.retention_months": "Kept for (months)",
    "screen.privacy.register.column.legal_hold": "Legal hold",
    "screen.privacy.register.column.version": "Version",
    "screen.privacy.register.column.recorded_at": "Since",
    "screen.privacy.register.stat.categories": "Categories",
    "screen.privacy.register.stat.held": "Under legal hold",
    "screen.privacy.register.action.create.field.category": "Category key",
    "screen.privacy.register.action.create.field.category.help": "Lower case and _ — what documents, attendance and media name when they ask how long to keep something.",
    "screen.privacy.register.action.create.field.name": "Name",
    "screen.privacy.register.action.create.field.purpose": "Purpose",
    "screen.privacy.register.action.create.field.basis": "Lawful basis",
    "screen.privacy.register.action.create.field.recipients": "Who receives it",
    "screen.privacy.register.action.create.field.retention_months": "Kept for (months)",
    "screen.privacy.register.action.create.field.legal_hold": "Legal hold",
    "screen.privacy.register.action.create.field.legal_hold.help": "A statute requires keeping it: nothing of this category is destroyed while this is on.",
    "screen.privacy.register.action.create.field.legal_hold_reason": "The law that requires it",
    "screen.privacy.register.action.create": "New category",
    "screen.privacy.register.action.revise.field.name": "Name",
    "screen.privacy.register.action.revise.field.purpose": "Purpose",
    "screen.privacy.register.action.revise.field.basis": "Lawful basis",
    "screen.privacy.register.action.revise.field.recipients": "Who receives it",
    "screen.privacy.register.action.revise.field.retention_months": "Kept for (months)",
    "screen.privacy.register.action.revise.field.legal_hold": "Legal hold",
    "screen.privacy.register.action.revise.field.legal_hold.help": "A statute requires keeping it: nothing of this category is destroyed while this is on.",
    "screen.privacy.register.action.revise.field.legal_hold_reason": "The law that requires it",
    "screen.privacy.register.action.revise": "New version",
    "screen.privacy.register.action.revise.field.name.help": "The version in force is kept and superseded; what the register said before can be read back.",
    "screen.privacy.register.title": "Processing register",
    "screen.privacy.register.lede": "What personal data this workspace processes, why, on which basis, who receives it and how long it is kept.",
    "screen.privacy.terms.column.key": "Period",
    "screen.privacy.terms.column.value": "Value",
    "screen.privacy.terms.column.effective_from": "In force from",
    "screen.privacy.terms.column.status": "Status",
    "screen.privacy.terms.column.confirmed_at": "Confirmed on",
    "screen.privacy.terms.stat.unconfirmed": "Unconfirmed",
    "screen.privacy.terms.action.confirm": "Confirm against the law",
    "screen.privacy.terms.title": "Legal periods",
    "screen.privacy.terms.lede": "The periods the law sets for answering requests and reporting breaches, confirmed here against the text.",
    "screen.privacy.requests.column.party_name": "Person",
    "screen.privacy.requests.column.party_id": "Person",
    "screen.privacy.requests.column.kind": "Request",
    "screen.privacy.requests.column.received_on": "Received",
    "screen.privacy.requests.column.deadline": "Answer by",
    "screen.privacy.requests.column.overdue": "Deadline",
    "screen.privacy.requests.column.verification": "Identity checked by",
    "screen.privacy.requests.column.status": "Status",
    "screen.privacy.requests.column.extension_reason": "Why it was extended",
    "screen.privacy.requests.column.decision_note": "Answer",
    "screen.privacy.requests.column.verified_at": "Identity checked on",
    "screen.privacy.requests.stat.open": "Open",
    "screen.privacy.requests.stat.overdue": "Past their deadline",
    "screen.privacy.requests.stat.answered": "Answered",
    "screen.privacy.requests.action.create.field.party_id": "Person",
    "screen.privacy.requests.action.create.field.kind": "Request",
    "screen.privacy.requests.action.create.field.received_on": "Received on",
    "screen.privacy.requests.action.create.field.received_on.help": "The deadline runs from this day. Empty: today.",
    "screen.privacy.requests.action.create.field.description": "What the person asked",
    "screen.privacy.requests.action.create": "New request",
    "screen.privacy.requests.action.verify.field.verification": "How the identity was checked",
    "screen.privacy.requests.action.verify.field.note": "Note",
    "screen.privacy.requests.action.verify": "Record the identity check",
    "screen.privacy.requests.action.note.field.note": "What was said or done",
    "screen.privacy.requests.action.note": "Write down what was said",
    "screen.privacy.requests.action.extend.field.reason": "Why more time is needed",
    "screen.privacy.requests.action.extend": "Extend once",
    "screen.privacy.requests.action.extend.field.reason.help": "Once, before the deadline, with the reason the person is told. Not by who opened the request.",
    "screen.privacy.requests.action.fulfil.field.note": "What was given or done",
    "screen.privacy.requests.action.fulfil": "Answer",
    "screen.privacy.requests.action.fulfil.field.note.help": "An erasure anonymises the person in the register — never a delete. A withdrawal of consent records their no. Not by who opened the request, and never about yourself.",
    "screen.privacy.requests.action.refuse.field.reason": "Why, as the person is told",
    "screen.privacy.requests.action.refuse": "Refuse",
    "screen.privacy.requests.title": "Data subject requests",
    "screen.privacy.requests.lede": "People's requests about their data, each answered within the period the law sets.",
    "screen.privacy.breaches.column.title": "Breach",
    "screen.privacy.breaches.column.severity": "Severity",
    "screen.privacy.breaches.column.discovered_at": "Discovered",
    "screen.privacy.breaches.column.notice_due_at": "Notice due",
    "screen.privacy.breaches.column.overdue": "Deadline",
    "screen.privacy.breaches.column.decision": "Decision",
    "screen.privacy.breaches.column.status": "Status",
    "screen.privacy.breaches.column.notified_at": "Notified on",
    "screen.privacy.breaches.column.notice_reference": "Authority's reference",
    "screen.privacy.breaches.column.decision_reason": "Reason",
    "screen.privacy.breaches.column.escalated_at": "Escalated on",
    "screen.privacy.breaches.stat.open": "Awaiting a decision",
    "screen.privacy.breaches.stat.overdue": "Past the notice deadline",
    "screen.privacy.breaches.stat.notified": "Notified",
    "screen.privacy.breaches.action.create.field.title": "What happened",
    "screen.privacy.breaches.action.create.field.discovered_on": "Discovered on",
    "screen.privacy.breaches.action.create.field.discovered_time": "At",
    "screen.privacy.breaches.action.create.field.discovered_time.help": "UTC+3. The notice clock runs from this moment.",
    "screen.privacy.breaches.action.create.field.severity": "Severity",
    "screen.privacy.breaches.action.create.field.subjects_estimate": "People affected (estimate)",
    "screen.privacy.breaches.action.create.field.categories": "Data categories",
    "screen.privacy.breaches.action.create.field.description": "Details",
    "screen.privacy.breaches.action.create": "Record a breach",
    "screen.privacy.breaches.action.escalate.field.note": "To whom, and what they were told",
    "screen.privacy.breaches.action.escalate": "Escalate",
    "screen.privacy.breaches.action.decide.field.decision": "Decision",
    "screen.privacy.breaches.action.decide.field.reason": "Reason",
    "screen.privacy.breaches.action.decide": "Decide on notice",
    "screen.privacy.breaches.action.decide.field.decision.help": "The controller decides; nothing is sent automatically. Not by who recorded the breach.",
    "screen.privacy.breaches.action.notified.field.notice_reference": "The authority's reference",
    "screen.privacy.breaches.action.notified": "Record the notice",
    "screen.privacy.breaches.action.close": "Close",
    "screen.privacy.breaches.title": "Breach log",
    "screen.privacy.breaches.lede": "Personal-data breaches with the clock the authority's notice runs on, the controller's decision to notify or not, and the evidence the notice went.",
    "nav.privacy.register": "Processing register",
    "nav.privacy.requests": "Data subject requests",
    "nav.privacy.breaches": "Breach log",
    "nav.privacy.terms": "Legal periods",
    "privacy.refusal.already_anonymised": "This person was already anonymised.",
    "privacy.refusal.basis": "Choose one of the lawful bases.",
    "privacy.refusal.category": "A category key is lower case letters, digits and _.",
    "privacy.refusal.category_taken": "The register already has this category: give it a new version instead.",
    "privacy.refusal.closed": "This is already decided or closed.",
    "privacy.refusal.decided": "The decision on this breach was already taken.",
    "privacy.refusal.decision": "Choose whether to notify the authority.",
    "privacy.refusal.discovered_at": "Say when it was discovered — not in the future.",
    "privacy.refusal.escalated": "This breach was already escalated.",
    "privacy.refusal.estimate": "The number of people affected is a whole number.",
    "privacy.refusal.extended_once": "A request is extended once, and this one was.",
    "privacy.refusal.extension_late": "The deadline has passed: an extension is asked for before it.",
    "privacy.refusal.extension_reason": "An extension says why, in a sentence the person is told.",
    "privacy.refusal.hold_reason": "A legal hold names the law that requires keeping the data.",
    "privacy.refusal.kind": "Choose what the person asks for.",
    "privacy.refusal.live_member": "The person still signs in here: end or suspend that access first.",
    "privacy.refusal.maker_checker": "Whoever opened or recorded it does not decide it: somebody else does.",
    "privacy.refusal.merged": "A merged party is anonymised through the party it was merged into.",
    "privacy.refusal.no_notice_reason": "Not notifying the authority is decided with the reason why.",
    "privacy.refusal.not_a_person": "Only a person is a data subject.",
    "privacy.refusal.not_access": "The data is handed over on an access request.",
    "privacy.refusal.not_decided": "A notice is recorded once the controller decided to notify.",
    "privacy.refusal.not_done": "A breach is closed once decided — and once the notice went, when it is to be notified.",
    "privacy.refusal.notified": "The notice was already recorded.",
    "privacy.refusal.notified_at": "Say when the notice went — not in the future.",
    "privacy.refusal.own_request": "Nobody decides a request about themselves.",
    "privacy.refusal.received_on": "A request is received on a day that has come.",
    "privacy.refusal.refusal_reason": "A refused request says why, in a sentence the person is told.",
    "privacy.refusal.retention": "The retention is a whole number of months, 1 to 1200.",
    "privacy.refusal.severity": "Choose the severity.",
    "privacy.refusal.superseded": "A superseded version is not revised: revise the current one.",
    "privacy.refusal.term_confirmed": "This period is already confirmed.",
    "privacy.refusal.unverified": "The person's identity is checked before the request is answered.",
    "privacy.refusal.verification": "Choose how the identity was checked.",
    "privacy.refusal.verified": "The person's identity was already checked.",
    "privacy.refusal.name_required": "A name is required.",
    "privacy.refusal.note_required": "Write the note.",
    "privacy.refusal.notice_reference_required": "The authority's reference is required.",
    "privacy.refusal.party_id_required": "Choose the person.",
    "privacy.refusal.purpose_required": "The purpose is required.",
    "privacy.refusal.title_required": "Say what happened.",
    "change.field.processing_activity.category": "Category",
    "change.field.processing_activity.version": "Version",
    "change.field.processing_activity.name": "Name",
    "change.field.processing_activity.purpose": "Purpose",
    "change.field.processing_activity.basis": "Lawful basis",
    "change.field.processing_activity.recipients": "Who receives it",
    "change.field.processing_activity.retention_months": "Kept for (months)",
    "change.field.processing_activity.legal_hold": "Legal hold",
    "change.field.processing_activity.legal_hold_reason": "The law that requires it",
    "change.field.processing_activity.superseded_at": "Superseded on",
    "change.field.processing_activity.superseded_by": "Superseded by",
    "change.field.privacy_term.key": "Period",
    "change.field.privacy_term.effective_from": "In force from",
    "change.field.privacy_term.value": "Value",
    "change.field.privacy_term.status": "Status",
    "change.field.privacy_term.confirmed_by": "Confirmed by",
    "change.field.privacy_term.confirmed_at": "Confirmed on",
    "change.field.privacy_term.note": "Note",
    "change.field.subject_request.party_id": "Person",
    "change.field.subject_request.kind": "Request",
    "change.field.subject_request.received_on": "Received on",
    "change.field.subject_request.description": "What the person asked",
    "change.field.subject_request.verified_at": "Identity checked on",
    "change.field.subject_request.verified_by": "Identity checked by",
    "change.field.subject_request.verification": "How the identity was checked",
    "change.field.subject_request.due_on": "Due on",
    "change.field.subject_request.extended_to": "Extended to",
    "change.field.subject_request.extension_reason": "Why it was extended",
    "change.field.subject_request.extended_by": "Extended by",
    "change.field.subject_request.status": "Status",
    "change.field.subject_request.decided_by": "Decided by",
    "change.field.subject_request.decision_note": "Answer",
    "change.field.subject_request.anonymised_at": "Anonymised on",
    "change.field.breach.title": "What happened",
    "change.field.breach.description": "Details",
    "change.field.breach.discovered_at": "Discovered",
    "change.field.breach.categories": "Data categories",
    "change.field.breach.subjects_estimate": "People affected (estimate)",
    "change.field.breach.severity": "Severity",
    "change.field.breach.notice_due_at": "Notice due",
    "change.field.breach.escalated_at": "Escalated on",
    "change.field.breach.escalated_by": "Escalated by",
    "change.field.breach.escalation_note": "Escalation note",
    "change.field.breach.decision": "Decision",
    "change.field.breach.decision_reason": "Reason",
    "change.field.breach.decided_by": "Decided by",
    "change.field.breach.notified_at": "Notified on",
    "change.field.breach.notice_reference": "Authority's reference",
    "change.field.breach.evidence_media_id": "Evidence file",
    "change.field.breach.status": "Status",
    "change.field.breach.closed_at": "Closed on",
    "change.field.party.anonymised_at": "Anonymised on",
};
export const PRIVACY_AR = {
    "privacy.basis.consent": "الموافقة",
    "privacy.basis.contract": "عقد مع الشخص",
    "privacy.basis.legal_obligation": "التزام نظامي",
    "privacy.basis.vital_interest": "مصلحة حيوية",
    "privacy.basis.public_interest": "مصلحة عامة",
    "privacy.basis.legitimate_interest": "مصلحة مشروعة",
    "privacy.kind.access": "الاطلاع على بياناته",
    "privacy.kind.correction": "التصحيح",
    "privacy.kind.erasure": "الإتلاف",
    "privacy.kind.withdraw_consent": "سحب الموافقة",
    "privacy.verification.in_person_id": "اطّلاع حضوري على وثيقة الهوية",
    "privacy.verification.nafath": "نفاذ",
    "privacy.verification.signed_request": "طلب موقّع",
    "privacy.verification.registered_contact": "من وسيلة التواصل المسجّلة",
    "privacy.severity.low": "منخفضة",
    "privacy.severity.medium": "متوسطة",
    "privacy.severity.high": "عالية",
    "privacy.decision.notify": "إبلاغ الجهة المختصة",
    "privacy.decision.no_notice": "عدم الإبلاغ",
    "privacy.term.request_days": "أيام الرد على الطلب",
    "privacy.term.extension_days": "أيام التمديد الواحد",
    "privacy.term.breach_notice_hours": "ساعات الإبلاغ عن التسرّب",
    "privacy.request_status.open": "مفتوح",
    "privacy.request_status.fulfilled": "أُجيب",
    "privacy.request_status.refused": "مرفوض",
    "privacy.breach_status.awaiting": "بانتظار القرار",
    "privacy.breach_status.ruled": "بُتّ فيه",
    "privacy.breach_status.notified": "أُبلغ عنه",
    "privacy.breach_status.concluded": "مغلق",
    "privacy.term_status.unconfirmed": "غير مؤكَّدة",
    "privacy.term_status.confirmed": "مؤكَّدة",
    "privacy.overdue.true": "متأخر",
    "privacy.overdue.false": "في الموعد",
    "privacy.hold.true": "حفظ نظامي",
    "privacy.hold.false": "بلا حفظ",
    "screen.privacy.register.column.name": "الاسم",
    "screen.privacy.register.column.category": "الفئة",
    "screen.privacy.register.column.basis": "الأساس النظامي",
    "screen.privacy.register.column.purpose": "الغرض",
    "screen.privacy.register.column.recipients": "من يتلقّاها",
    "screen.privacy.register.column.retention_months": "مدة الحفظ (بالأشهر)",
    "screen.privacy.register.column.legal_hold": "حفظ نظامي",
    "screen.privacy.register.column.version": "الإصدار",
    "screen.privacy.register.column.recorded_at": "منذ",
    "screen.privacy.register.stat.categories": "الفئات",
    "screen.privacy.register.stat.held": "تحت حفظ نظامي",
    "screen.privacy.register.action.create.field.category": "مفتاح الفئة",
    "screen.privacy.register.action.create.field.category.help": "بأحرف لاتينية صغيرة و_ — ما تسمّيه الوثائق والحضور والملفات حين تسأل عن مدة الحفظ.",
    "screen.privacy.register.action.create.field.name": "الاسم",
    "screen.privacy.register.action.create.field.purpose": "الغرض",
    "screen.privacy.register.action.create.field.basis": "الأساس النظامي",
    "screen.privacy.register.action.create.field.recipients": "من يتلقّاها",
    "screen.privacy.register.action.create.field.retention_months": "مدة الحفظ (بالأشهر)",
    "screen.privacy.register.action.create.field.legal_hold": "حفظ نظامي",
    "screen.privacy.register.action.create.field.legal_hold.help": "نظامٌ يوجب حفظها: لا يُتلف شيء من هذه الفئة ما دام هذا مفعّلًا.",
    "screen.privacy.register.action.create.field.legal_hold_reason": "النظام الذي يوجبه",
    "screen.privacy.register.action.create": "فئة جديدة",
    "screen.privacy.register.action.revise.field.name": "الاسم",
    "screen.privacy.register.action.revise.field.purpose": "الغرض",
    "screen.privacy.register.action.revise.field.basis": "الأساس النظامي",
    "screen.privacy.register.action.revise.field.recipients": "من يتلقّاها",
    "screen.privacy.register.action.revise.field.retention_months": "مدة الحفظ (بالأشهر)",
    "screen.privacy.register.action.revise.field.legal_hold": "حفظ نظامي",
    "screen.privacy.register.action.revise.field.legal_hold.help": "نظامٌ يوجب حفظها: لا يُتلف شيء من هذه الفئة ما دام هذا مفعّلًا.",
    "screen.privacy.register.action.revise.field.legal_hold_reason": "النظام الذي يوجبه",
    "screen.privacy.register.action.revise": "إصدار جديد",
    "screen.privacy.register.action.revise.field.name.help": "يُحفظ الإصدار النافذ ويُستبدل؛ ويمكن قراءة ما كان يقوله السجل من قبل.",
    "screen.privacy.register.title": "سجل المعالجة",
    "screen.privacy.register.lede": "ما تعالجه مساحة العمل من بيانات شخصية، ولماذا، وعلى أي أساس، ومن يتلقّاها، وكم تُحفظ.",
    "screen.privacy.terms.column.key": "المدة",
    "screen.privacy.terms.column.value": "القيمة",
    "screen.privacy.terms.column.effective_from": "نافذة من",
    "screen.privacy.terms.column.status": "الحالة",
    "screen.privacy.terms.column.confirmed_at": "أُكّدت في",
    "screen.privacy.terms.stat.unconfirmed": "غير مؤكَّدة",
    "screen.privacy.terms.action.confirm": "تأكيد مطابقتها للنظام",
    "screen.privacy.terms.title": "المدد النظامية",
    "screen.privacy.terms.lede": "المدد التي يحدّدها النظام للرد على الطلبات والإبلاغ عن التسرّبات، وتُؤكَّد هنا مقابل النص.",
    "screen.privacy.requests.column.party_name": "الشخص",
    "screen.privacy.requests.column.party_id": "الشخص",
    "screen.privacy.requests.column.kind": "الطلب",
    "screen.privacy.requests.column.received_on": "ورد في",
    "screen.privacy.requests.column.deadline": "يُجاب قبل",
    "screen.privacy.requests.column.overdue": "الموعد",
    "screen.privacy.requests.column.verification": "تحقُّق الهوية عبر",
    "screen.privacy.requests.column.status": "الحالة",
    "screen.privacy.requests.column.extension_reason": "سبب التمديد",
    "screen.privacy.requests.column.decision_note": "الرد",
    "screen.privacy.requests.column.verified_at": "تُحقّق من الهوية في",
    "screen.privacy.requests.stat.open": "مفتوحة",
    "screen.privacy.requests.stat.overdue": "تجاوزت موعدها",
    "screen.privacy.requests.stat.answered": "أُجيبت",
    "screen.privacy.requests.action.create.field.party_id": "الشخص",
    "screen.privacy.requests.action.create.field.kind": "الطلب",
    "screen.privacy.requests.action.create.field.received_on": "ورد في",
    "screen.privacy.requests.action.create.field.received_on.help": "يبدأ الموعد من هذا اليوم. فارغ: اليوم.",
    "screen.privacy.requests.action.create.field.description": "ما طلبه الشخص",
    "screen.privacy.requests.action.create": "طلب جديد",
    "screen.privacy.requests.action.verify.field.verification": "كيف تُحقّق من الهوية",
    "screen.privacy.requests.action.verify.field.note": "ملاحظة",
    "screen.privacy.requests.action.verify": "تسجيل التحقّق من الهوية",
    "screen.privacy.requests.action.note.field.note": "ما قيل أو فُعل",
    "screen.privacy.requests.action.note": "تدوين ما قيل",
    "screen.privacy.requests.action.extend.field.reason": "لماذا يلزم وقت أطول",
    "screen.privacy.requests.action.extend": "تمديد مرة واحدة",
    "screen.privacy.requests.action.extend.field.reason.help": "مرة واحدة، قبل الموعد، مع السبب الذي يُبلَّغ به الشخص. لا يمدّده من فتح الطلب.",
    "screen.privacy.requests.action.fulfil.field.note": "ما قُدّم أو فُعل",
    "screen.privacy.requests.action.fulfil": "الإجابة",
    "screen.privacy.requests.action.fulfil.field.note.help": "الإتلاف يُجهّل الشخص في السجل — لا حذف أبدًا. وسحب الموافقة يُسجّل رفضه. لا يُجيبه من فتح الطلب، ولا أحدٌ عن نفسه.",
    "screen.privacy.requests.action.refuse.field.reason": "السبب كما يُبلَّغ به الشخص",
    "screen.privacy.requests.action.refuse": "رفض",
    "screen.privacy.requests.title": "طلبات أصحاب البيانات",
    "screen.privacy.requests.lede": "طلبات الأشخاص بشأن بياناتهم، ويُجاب كلٌّ منها في المدة التي يحدّدها النظام.",
    "screen.privacy.breaches.column.title": "التسرّب",
    "screen.privacy.breaches.column.severity": "الخطورة",
    "screen.privacy.breaches.column.discovered_at": "اكتُشف في",
    "screen.privacy.breaches.column.notice_due_at": "موعد الإبلاغ",
    "screen.privacy.breaches.column.overdue": "الموعد",
    "screen.privacy.breaches.column.decision": "القرار",
    "screen.privacy.breaches.column.status": "الحالة",
    "screen.privacy.breaches.column.notified_at": "أُبلغ في",
    "screen.privacy.breaches.column.notice_reference": "مرجع الجهة المختصة",
    "screen.privacy.breaches.column.decision_reason": "السبب",
    "screen.privacy.breaches.column.escalated_at": "صُعّد في",
    "screen.privacy.breaches.stat.open": "بانتظار القرار",
    "screen.privacy.breaches.stat.overdue": "تجاوز موعد الإبلاغ",
    "screen.privacy.breaches.stat.notified": "أُبلغ عنها",
    "screen.privacy.breaches.action.create.field.title": "ما الذي حدث",
    "screen.privacy.breaches.action.create.field.discovered_on": "اكتُشف في",
    "screen.privacy.breaches.action.create.field.discovered_time": "الساعة",
    "screen.privacy.breaches.action.create.field.discovered_time.help": "بتوقيت UTC+3. تبدأ مهلة الإبلاغ من هذه اللحظة.",
    "screen.privacy.breaches.action.create.field.severity": "الخطورة",
    "screen.privacy.breaches.action.create.field.subjects_estimate": "عدد المتأثرين (تقديرًا)",
    "screen.privacy.breaches.action.create.field.categories": "فئات البيانات",
    "screen.privacy.breaches.action.create.field.description": "التفاصيل",
    "screen.privacy.breaches.action.create": "تسجيل تسرّب",
    "screen.privacy.breaches.action.escalate.field.note": "إلى من، وبماذا أُبلغ",
    "screen.privacy.breaches.action.escalate": "تصعيد",
    "screen.privacy.breaches.action.decide.field.decision": "القرار",
    "screen.privacy.breaches.action.decide.field.reason": "السبب",
    "screen.privacy.breaches.action.decide": "البتّ في الإبلاغ",
    "screen.privacy.breaches.action.decide.field.decision.help": "يقرّر المتحكّم؛ لا يُرسَل شيء تلقائيًا. لا يبتّ فيه من سجّل التسرّب.",
    "screen.privacy.breaches.action.notified.field.notice_reference": "مرجع الجهة المختصة",
    "screen.privacy.breaches.action.notified": "تسجيل الإبلاغ",
    "screen.privacy.breaches.action.close": "إغلاق",
    "screen.privacy.breaches.title": "سجل التسرّبات",
    "screen.privacy.breaches.lede": "تسرّبات البيانات الشخصية مع مهلة الإبلاغ، وقرار المتحكّم بالإبلاغ أو عدمه، ودليل إرسال الإبلاغ.",
    "nav.privacy.register": "سجل المعالجة",
    "nav.privacy.requests": "طلبات أصحاب البيانات",
    "nav.privacy.breaches": "سجل التسرّبات",
    "nav.privacy.terms": "المدد النظامية",
    "privacy.refusal.already_anonymised": "سبق تجهيل هذا الشخص.",
    "privacy.refusal.basis": "اختر أحد الأسس النظامية.",
    "privacy.refusal.category": "مفتاح الفئة أحرف لاتينية صغيرة وأرقام و_.",
    "privacy.refusal.category_taken": "الفئة موجودة في السجل: أصدر لها نسخة جديدة بدل ذلك.",
    "privacy.refusal.closed": "سبق البتّ في هذا أو إغلاقه.",
    "privacy.refusal.decided": "سبق البتّ في هذا التسرّب.",
    "privacy.refusal.decision": "اختر إن كانت الجهة المختصة ستُبلَّغ.",
    "privacy.refusal.discovered_at": "اذكر متى اكتُشف — لا في المستقبل.",
    "privacy.refusal.escalated": "سبق تصعيد هذا التسرّب.",
    "privacy.refusal.estimate": "عدد المتأثرين عدد صحيح.",
    "privacy.refusal.extended_once": "يُمدَّد الطلب مرة واحدة، وقد مُدّد.",
    "privacy.refusal.extension_late": "انقضى الموعد: يُطلب التمديد قبله.",
    "privacy.refusal.extension_reason": "يُذكر سبب التمديد في جملة يُبلَّغ بها الشخص.",
    "privacy.refusal.hold_reason": "يُسمّي الحفظ النظامي النظام الذي يوجب الحفظ.",
    "privacy.refusal.kind": "اختر ما يطلبه الشخص.",
    "privacy.refusal.live_member": "ما زال الشخص يدخل هنا: أنهِ ذلك الدخول أو أوقفه أولًا.",
    "privacy.refusal.maker_checker": "من فتحه أو سجّله لا يبتّ فيه: يبتّ فيه غيره.",
    "privacy.refusal.merged": "الطرف المدموج يُجهَّل عبر الطرف الذي دُمج فيه.",
    "privacy.refusal.no_notice_reason": "عدم إبلاغ الجهة المختصة يُقرَّر مع سببه.",
    "privacy.refusal.not_a_person": "صاحب البيانات شخص طبيعي فقط.",
    "privacy.refusal.not_access": "تُسلَّم البيانات في طلب الاطلاع.",
    "privacy.refusal.not_decided": "يُسجَّل الإبلاغ بعد أن يقرّر المتحكّم الإبلاغ.",
    "privacy.refusal.not_done": "يُغلق التسرّب بعد البتّ — وبعد إرسال الإبلاغ إن تقرّر.",
    "privacy.refusal.notified": "سبق تسجيل الإبلاغ.",
    "privacy.refusal.notified_at": "اذكر متى أُرسل الإبلاغ — لا في المستقبل.",
    "privacy.refusal.own_request": "لا يبتّ أحدٌ في طلب يخصّه.",
    "privacy.refusal.received_on": "يرد الطلب في يوم قد حلّ.",
    "privacy.refusal.refusal_reason": "يُذكر سبب رفض الطلب في جملة يُبلَّغ بها الشخص.",
    "privacy.refusal.retention": "مدة الحفظ عدد صحيح من الأشهر، من 1 إلى 1200.",
    "privacy.refusal.severity": "اختر الخطورة.",
    "privacy.refusal.superseded": "الإصدار المستبدَل لا يُعدَّل: عدّل الإصدار النافذ.",
    "privacy.refusal.term_confirmed": "هذه المدة مؤكَّدة من قبل.",
    "privacy.refusal.unverified": "يُتحقّق من هوية الشخص قبل الإجابة.",
    "privacy.refusal.verification": "اختر كيف تُحقّق من الهوية.",
    "privacy.refusal.verified": "سبق التحقّق من هوية الشخص.",
    "privacy.refusal.name_required": "الاسم مطلوب.",
    "privacy.refusal.note_required": "اكتب الملاحظة.",
    "privacy.refusal.notice_reference_required": "مرجع الجهة المختصة مطلوب.",
    "privacy.refusal.party_id_required": "اختر الشخص.",
    "privacy.refusal.purpose_required": "الغرض مطلوب.",
    "privacy.refusal.title_required": "اذكر ما الذي حدث.",
    "change.field.processing_activity.category": "الفئة",
    "change.field.processing_activity.version": "الإصدار",
    "change.field.processing_activity.name": "الاسم",
    "change.field.processing_activity.purpose": "الغرض",
    "change.field.processing_activity.basis": "الأساس النظامي",
    "change.field.processing_activity.recipients": "من يتلقّاها",
    "change.field.processing_activity.retention_months": "مدة الحفظ (بالأشهر)",
    "change.field.processing_activity.legal_hold": "حفظ نظامي",
    "change.field.processing_activity.legal_hold_reason": "النظام الذي يوجبه",
    "change.field.processing_activity.superseded_at": "استُبدل في",
    "change.field.processing_activity.superseded_by": "استبدله",
    "change.field.privacy_term.key": "المدة",
    "change.field.privacy_term.effective_from": "نافذة من",
    "change.field.privacy_term.value": "القيمة",
    "change.field.privacy_term.status": "الحالة",
    "change.field.privacy_term.confirmed_by": "أكّدها",
    "change.field.privacy_term.confirmed_at": "أُكّدت في",
    "change.field.privacy_term.note": "ملاحظة",
    "change.field.subject_request.party_id": "الشخص",
    "change.field.subject_request.kind": "الطلب",
    "change.field.subject_request.received_on": "ورد في",
    "change.field.subject_request.description": "ما طلبه الشخص",
    "change.field.subject_request.verified_at": "تُحقّق من الهوية في",
    "change.field.subject_request.verified_by": "تحقّق من الهوية",
    "change.field.subject_request.verification": "كيف تُحقّق من الهوية",
    "change.field.subject_request.due_on": "الموعد",
    "change.field.subject_request.extended_to": "مُدّد إلى",
    "change.field.subject_request.extension_reason": "سبب التمديد",
    "change.field.subject_request.extended_by": "مدّده",
    "change.field.subject_request.status": "الحالة",
    "change.field.subject_request.decided_by": "بتّ فيه",
    "change.field.subject_request.decision_note": "الرد",
    "change.field.subject_request.anonymised_at": "جُهّل في",
    "change.field.breach.title": "ما الذي حدث",
    "change.field.breach.description": "التفاصيل",
    "change.field.breach.discovered_at": "اكتُشف في",
    "change.field.breach.categories": "فئات البيانات",
    "change.field.breach.subjects_estimate": "عدد المتأثرين (تقديرًا)",
    "change.field.breach.severity": "الخطورة",
    "change.field.breach.notice_due_at": "موعد الإبلاغ",
    "change.field.breach.escalated_at": "صُعّد في",
    "change.field.breach.escalated_by": "صعّده",
    "change.field.breach.escalation_note": "ملاحظة التصعيد",
    "change.field.breach.decision": "القرار",
    "change.field.breach.decision_reason": "السبب",
    "change.field.breach.decided_by": "بتّ فيه",
    "change.field.breach.notified_at": "أُبلغ في",
    "change.field.breach.notice_reference": "مرجع الجهة المختصة",
    "change.field.breach.evidence_media_id": "ملف الدليل",
    "change.field.breach.status": "الحالة",
    "change.field.breach.closed_at": "أُغلق في",
    "change.field.party.anonymised_at": "جُهّل في",
};
//# sourceMappingURL=i18n-privacy.js.map